import URLS from '@/server/urls';
import { GET } from '@/server/http';

export default async ({
    count = -1,
}, options = { showError: true }) => {
    const [ content, error, status ] = await GET(URLS.role.getList, { count }, options);
    if (error) return { error, status };
    return content || {};
};
